export interface ProfileClass {
    AccountEmployeeId: number
    Password: string
    NewPassword:string
    VerifyPassword:string
    FirstName: string
    LastName: string
    MiddleName: string
    Username: string
    EMailAddress: string
    AddressLine1: string
    AddressLine2: string
    State: string
    City: string
    Zip: string
    CountryId:number
    HomePhoneNo: string
    WorkPhoneNo: string
    MobilePhoneNo: string
    TimeZoneId:number
    UserInterfaceLanguage:string
    IsTimeInOutAvailable:boolean
    IsShowEmployeeProfilePicture:boolean
    AuthenticationToken:string
    
}


export const ProfileInitialsForUpdate = {
    AccountEmployeeId: 0,
    Password: "",
    NewPassword:"",
    VerifyPassword:"",
    FirstName: "",
    LastName: "",
    MiddleName: "",
    Username: "",
    EMailAddress: "",
    AddressLine1: "",
    AddressLine2: "",
    State: "",
    City: "",
    Zip: "",
    CountryId:0,
    HomePhoneNo: "",
    WorkPhoneNo: "",
    MobilePhoneNo: "",
    TimeZoneId:0,
    UserInterfaceLanguage:"",
    IsTimeInOutAvailable:false,
    IsShowEmployeeProfilePicture:false,
    AuthenticationToken:''
};

